import Post from "../Entity/Post";
import * as Yup from "yup";
import CrudApi from "@serie3/common/api/crudApi";
import SocialEndpoints from "../endpoints";
import listHandler from "@serie3/common/Domain/listHandler";

// `dataList` may be the array itself or a getter returning the current array.
// PostFormView passes a getter because it memoizes the form config once, and a
// captured array goes stale as soon as the board list changes.
const resolveList = (dataList) =>
  typeof dataList === "function" ? dataList() : dataList;

const createPostForm = (
  dataList,
  setDataFunction,
  setAdditionalData,
  saveVariant = false,
  customListHandler = false,
  setSaving = null
) => {
  const validationSchema = Yup.object({
    Tipp: Yup.string().required("Required"),
  });

  const editFunction = async (values, originalValues) => {
    setSaving && setSaving(true);
    let payload = JSON.stringify(values, null, 2);
    const response = await CrudApi.edit(SocialEndpoints.posts.edit, payload, true);
    setSaving && setSaving(false);
    const currentList = resolveList(dataList);
    if (currentList && customListHandler == false) {
      let originalPayload = JSON.stringify(response.data, null, 2);
      listHandler.updateList(
        response,
        originalPayload,
        currentList,
        setDataFunction
      );
    }else{
        customListHandler && customListHandler(response);
    }
  };

  const onSubmit = async (values) => {
    const originalValues = { ...values };
    if (values.id > 0) {
      editFunction(values, originalValues);
    } else {
      let payload = JSON.stringify(values, null, 2);
      const response = await CrudApi.createNew(
        SocialEndpoints.posts.new,
        payload
      );
      const currentList = resolveList(dataList);
      if (currentList) {
        listHandler.newToList(response, currentList, setDataFunction, null, true);

        if (response.ok) {
          values.id = response.data.id;
          let additionalData = {
            id: response.data.id,
          };
          setAdditionalData && setAdditionalData(additionalData);

          if (saveVariant) {
            const originalValues = { ...values };
            editFunction(values, originalValues);
          }
        }
      }
    }
  };

  return {
    initialValues: Post,
    onSubmit: (values, actions) => {
      onSubmit(values);
    },
  };
};

const setEditData = (editData) => {
  let Post = {
    id: editData.id,
    title: editData.title,
    text: editData.text,
    content_type: editData.content_type,
    post_type: editData.post_type,
    content_pillar: editData.content_pillar
      ? { id: editData.content_pillar.id }
      : null,
    tags: editData.tags ?? [],
    no_recycle: editData.no_recycle ?? false,
    funnel_stage: editData.funnel_stage ?? null,
  };

  return Post;
};

export default { createPostForm, setEditData };
